import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-validation-message',
  templateUrl: './validation-message.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ValidationMessageComponent {
  @Input() public field: UntypedFormControl;
  @Input() public displayName: string;
  @Input() public isFile = false;
}
